import {Celsius, Fahrenheit, Kelvin, TemperatureContext} from "./generic/temperature";
import Icon from "@mdi/react";
import {mdiRefresh, mdiThemeLightDark} from "@mdi/js";
import {Dropdown} from "./generic/dropdown";
import {FetchContext, FetchProps} from "./fetchAndRender";
import {GlobalData, GlobalDataContext} from "../app";
import {useContext} from "preact/hooks";
import styled, {DefaultTheme, ThemeConsumer} from "styled-components";
import LightTheme from "../theme/light";
import DarkTheme from "../theme/dark";
import {Button, ButtonList} from "./generic/button";
import {PopupMenu} from "./generic/menu";
import {HorizontalNav} from "./generic/nav";
import {HTMLProps} from "react";

export type FooterProps = {
    version?: string;
    temperatureContexts?: TemperatureContext[];
    switchTemperatureContext: (newContext: TemperatureContext) => void;
    switchInterval: (newInterval: number) => void;
} & HTMLProps<HTMLElement>;

export const Footer = styled(function ({
    version,
    temperatureContexts: propsTemperatureContexts,
    switchTemperatureContext,
    switchInterval,
    ...props
}: FooterProps) {
    const temperatureContexts = propsTemperatureContexts ?? [Celsius, Fahrenheit, Kelvin];
    const switchIntervals: {[key: number]: string} = {
        0: "Off",
        5: "5s",
        10: "10s",
        30: "30s",
        60: "1m",
        300: "5m",
        600: "10m",
        900: "15m",
        1800: "30m",
        3600: "1h",
        7200: "2h",
        86400: "1d",
    };

    const globalData = useContext(GlobalDataContext) as GlobalData;

    return <footer {...props}>
        <ButtonList>
                <ThemeConsumer>{(theme: DefaultTheme) =>
                    <Button
                        title="Switch light/dark theme."
                        className="btn"
                        onClick={(e: MouseEvent) => {
                            globalData.switchTheme(theme.bodyClass == LightTheme.bodyClass ? DarkTheme : LightTheme);
                            e.preventDefault();
                            e.stopPropagation();
                        }}>
                        <Icon size="1.2em" path={mdiThemeLightDark} />
                    </Button>
                }</ThemeConsumer>
                <TemperatureContext.Consumer>{(context: TemperatureContext) =>
                    <Dropdown
                        content={<PopupMenu>{temperatureContexts.map(tCtx =>
                            <li className={tCtx == context ? "popup-selected" : ""}>
                                <Button
                                    className="btn"
                                    onClick={() => {
                                        //toggleTemperatureSelector(false);
                                        switchTemperatureContext(tCtx);
                                    }}
                                >
                                    {tCtx.unit}
                                </Button>
                            </li>
                        )}</PopupMenu>}
                        position={"top"}
                        title="Change temperature units"
                    >{context.unit}</Dropdown>
                }</TemperatureContext.Consumer>
                <FetchContext.Consumer>{(ctx: FetchProps) =>
                    <Dropdown
                        content={<PopupMenu class="popup">{Object.keys(switchIntervals).map(key =>
                            <li>
                                <Button
                                    className="btn"
                                    onClick={() => switchInterval(Number.parseInt(key))}
                                >
                                    {switchIntervals[Number.parseInt(key)]}
                                </Button>
                            </li>)
                        }</PopupMenu>}
                        position={"top"}
                        title="Change refresh interval"
                    ><Icon path={mdiRefresh} size="1em" /> {switchIntervals[ctx.interval as number]}</Dropdown>
                }</FetchContext.Consumer>
        </ButtonList>
        <div class="text-right">
            <a href="/changelog" title="Changelog">{version ?? "v0.0.0"}</a> | <a href="https://gitlab.com/gcm-cz/temperature">GitLab</a>
        </div>
    </footer>
})`
    background: ${props => props.theme.colors.secondaryBg};
    color: ${props => props.theme.colors.secondaryFg};
    font-size: .8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .5rem 1rem;
`;
